import React, { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as EmailIcon } from '../../../../../assets/images/emailIcon.svg';
import { ReactComponent as TrashcanIcon } from '../../../../../assets/images/trashcanIcon.svg';
import { deleteEmail, updatePrimaryEmail } from '../../../../../redux/actions/userActions';
import DeleteEmailModal from '../DeleteEmailModal/DeleteEmailModal';
import PrimaryEmailModal from '../PrimaryEmailModal/PrimaryEmailModal';

import styles from './EmailRow.module.scss';

const EmailRow = ({ emailData }) => {
  const { t } = useTranslation('common');
  const dispatch = useDispatch();
  const { id, email, primary, pending } = emailData;

  const userId = useSelector((state) => state.authReducer.currentUser.user?.id);

  const [showPrimaryEmailModal, setShowPrimaryEmailModal] = useState(false);
  const [showDeleteEmailModal, setShowDeleteEmailModal] = useState(false);

  const handleUpdatePrimaryEmail = useCallback(
    (password) => {
      dispatch(updatePrimaryEmail(id, password, userId, () => setShowPrimaryEmailModal(false)));
    },
    [id, userId]
  );

  const handleDeleteEmail = useCallback(() => {
    dispatch(deleteEmail(id, () => setShowDeleteEmailModal(false)));
  }, [id]);

  return (
    <div className={styles.container}>
      <div className={styles.emailContainer}>
        <EmailIcon />
        <div className={styles.emailDetails}>
          <span className={pending ? styles.greyed : ''}>
            {email}
            {pending && (
              <span className={styles.pendingText}>
                &nbsp;({t('pending')})
                <br />
                <em>{t('emailModals.checkEmailConfirmation')}</em>
              </span>
            )}
          </span>
          {!pending &&
            (primary ? (
              <span>{t('emailModals.primary')}</span>
            ) : (
              <button type="button" onClick={() => setShowPrimaryEmailModal(true)}>
                {t('emailModals.makePrimary')}
              </button>
            ))}
        </div>
      </div>
      {!primary && (
        <span className={styles.deleteIcon}>
          <TrashcanIcon onClick={() => setShowDeleteEmailModal(true)} />
        </span>
      )}
      {showPrimaryEmailModal && (
        <PrimaryEmailModal
          show={showPrimaryEmailModal}
          onHide={() => setShowPrimaryEmailModal(false)}
          handleSubmit={handleUpdatePrimaryEmail}
        />
      )}
      {showDeleteEmailModal && (
        <DeleteEmailModal
          show={showDeleteEmailModal}
          onHide={() => setShowDeleteEmailModal(false)}
          handleSubmit={handleDeleteEmail}
        />
      )}
    </div>
  );
};

export default EmailRow;
